/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Globals from "../shared/Globals";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Icon from "./Icon";

export default class Editable extends BaseCom {

    componentDidMount() {
        this.setState({ value: this.props.value });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value });
        }
    }

    toggleEdit = () => {
        this.setState({ edit: !this.state.edit, value: this.props.value });
    }

    change = (e) => {
        this.setState({ value: e.target.value });
    }

    apply = () => {
        this.props.onChange?.(this.state.value);
        this.setState({ edit: false });
    }

    cancel = () => {
        this.setState({ edit: false });
    }
    
    keyUp = (e) => {
        if(e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            this.apply();
        }
    }

    render() {
        return this.state.edit ? <div className="input-group">
            <input type={this.props.currency ? 'number' : 'text'} className="form-control" value={this.state.value} onChange={(e) => this.change(e)} onKeyUp={this.keyUp} />
            <div className="input-group-text" role="button" onClick={() => this.apply()}><Icon icon="faSave" /></div>
            <div className="input-group-text" role="button" onClick={() => this.cancel()}><Icon icon="faTimes" /></div>
        </div> : <>
            <span>
                {this.props.currency && Globals.formatCurrency(this.props.value)}
                {!this.props.currency && this.props.value}
            </span>
            {!this.props.disabled && <span role="button" className="btn ms-md-2" onClick={() => this.toggleEdit()}><Icon icon="faEdit" /></span>}
        </>;
    }
}